// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__19CrO","itemA":"Write_itemA__2tNwX","itemB":"Write_itemB__riCme","itemC":"Write_itemC__1cFxn","itemD":"Write_itemD__1hw6x"};